import { NgModule } from '@angular/core';
import { OccTrackingPickupNormalizer, TRACKING_PICKUP_NORMALIZER } from './converters';
import { TMS_TRACKING_API_NORMALIZER, TmsTrackingApiNormalizer } from './converters/tms-tracking-api-normalizer';

@NgModule({
  providers: [
    { provide: TMS_TRACKING_API_NORMALIZER, useClass: TmsTrackingApiNormalizer, multi: true },

    {
      provide: TRACKING_PICKUP_NORMALIZER,
      useExisting: OccTrackingPickupNormalizer,
      multi: true,
    },
  ],
})
export class TrackingUtilsModule {}
